import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLunch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "dinner",
	"data-name": "dinner",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: .5,
			x2: 12,
			y2: 2.42
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: 21.58,
			x2: 12,
			y2: 23.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 23.5,
			y1: 12,
			x2: 21.58,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 2.42,
			y1: 12,
			x2: .5,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: .5,
			x2: 12,
			y2: 2.42
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: 21.58,
			x2: 12,
			y2: 23.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 23.5,
			y1: 12,
			x2: 21.58,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 2.42,
			y1: 12,
			x2: .5,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 20.13,
			y1: 3.87,
			x2: 18.78,
			y2: 5.22
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.22,
			y1: 18.78,
			x2: 3.87,
			y2: 20.13
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 20.13,
			y1: 20.13,
			x2: 18.78,
			y2: 18.78
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.22,
			y1: 5.22,
			x2: 3.87,
			y2: 3.87
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 20.13,
			y1: 3.87,
			x2: 18.78,
			y2: 5.22
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.22,
			y1: 18.78,
			x2: 3.87,
			y2: 20.13
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 20.13,
			y1: 20.13,
			x2: 18.78,
			y2: 18.78
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 5.22,
			y1: 5.22,
			x2: 3.87,
			y2: 3.87
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 12,
			cy: 12,
			r: 6.71
		})
	]
});
const ForwardRef = forwardRef(SvgLunch);
export default ForwardRef;
